import {
  Component,
  ChangeDetectionStrategy, Input, Output, EventEmitter,
} from '@angular/core';
import { Property } from '../../../property/shared/models';
import { ExportMap } from '../../shared/models';

@Component({
  selector: 'sp-admin-property-export-map-details',
  templateUrl: './admin-property-export-map-details.component.html',
  styleUrls: ['./admin-property-export-map-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminPropertyExportMapDetailsComponent {

  @Input() exportMap: ExportMap;
  @Input() property: Property;
  @Output() submit = new EventEmitter<number>();
  @Output() export = new EventEmitter<void>();

  onExport() {
    this.export.emit();
  }
}
